import { useState } from "react";
import {
  Button,
  DataGrid,
  DialogActions,
  DialogContent,
  Grid,
} from "../../../../../components";
import { SelecionarArquivoCsvStep } from "./steps";
import * as XLSX from "xlsx";
import {
  formatCnpj,
  formatCpf,
  formatTelefone,
  responseErros,
} from "../../../../../utils";
import shortid from "shortid";
import pessoasCsvValidator from "./middlewares/pessoas-csv.validator";
import { notification, PessoaService } from "../../../../../services";

const ImportarCsvStepper = ({
  activeStep,
  setActiveStep,
  setOpenImportarCSVDialog,
  arquivoCsv,
  setArquivoCsv,
  obrigadoriedadeCnpjCpf,
}) => {
  const [data, setData] = useState([]);
  const pessoaService = new PessoaService();
  const pessoaValidatorService = pessoasCsvValidator(obrigadoriedadeCnpjCpf);

  const colunas = [
    {
      field: "nomeRazaoSocial",
      headerName: "Nome / Razão Social",
      flex: 700,
      filtrar: true,
    },
    {
      field: "cnpjCpf",
      headerName: "CNPJ / CPF",
      sortable: false,
      flex: 300,
      valueGetter: (params) =>
        params.row.naturezaSocial === "fisica"
          ? formatCpf(params.value)
          : formatCnpj(params.value),
    },
    { field: "email", headerName: "Email", flex: 350 },
    {
      field: "telefone",
      headerName: "Telefone",
      flex: 300,
      valueGetter: (params) => formatTelefone(params.value),
    },
  ];

  function converterDadosCsv(csvData) {
    let worksheets = {
      pessoas: null,
      idTiposPessoa: [],
      cliente: [],
      fornecedor: [],
      transportadora: [],
      colaborador: [],
      prestadorServico: [],
    };
    const workbook = XLSX.read(csvData, { type: "buffer" });
    const sheetsNames = workbook.SheetNames;
    worksheets.pessoas = XLSX.utils.sheet_to_json(
      workbook.Sheets[sheetsNames[0]],
    );
    sheetsNames.map((name) => {
      const keys = Object.keys(worksheets);
      if (keys.includes(name)) {
        worksheets[name] = XLSX.utils.sheet_to_json(workbook.Sheets[name]);
      }
    });
    return worksheets;
  }

  function extrairDadosPessoas(csvData) {
    let pessoas = [];
    const dataMain = converterDadosCsv(csvData);
    if (dataMain.pessoas?.length) {
      let dadosMap = { ...dataMain };
      delete dadosMap.pessoas;
      for (let i = 0; i < dataMain.pessoas.length; i++) {
        const pessoa = dataMain.pessoas[i];
        const vinculos = { id: shortid.generate(), ...pessoa };
        Object.keys(dadosMap).forEach((key) => {
          const dadosVinculados = dataMain[key]?.length
            ? dataMain[key].filter((dado) => dado.vinculo === pessoa.vinculo)
            : null;
          if (key === "idTiposPessoa")
            vinculos[key] = dadosVinculados[0].ids
              .split(",")
              .map((id) => Number(id.trim()));
          else vinculos[key] = dadosVinculados[0];
        });
        pessoas.push(vinculos);
      }
      return pessoas;
    }
  }

  const handleFileRead = async (e) => {
    const csvData = e.target.result;
    const jsonData = extrairDadosPessoas(csvData);
    setData(jsonData);
  };

  const buscarCsvData = () => {
    const reader = new FileReader();
    reader.onload = (e) => handleFileRead(e);
    reader.readAsArrayBuffer(arquivoCsv);
  };

  function handleSubmit() {
    pessoaValidatorService
      .validate(data, { abortEarly: false })
      .then(async () => {
        try {
          const result = await pessoaService.cadastrarLista(data);
          if (!result.isAxiosError) {
            notification.cadastroSucesso();
          } else {
            responseErros(result);
          }
        } catch (error) {
          console.log(error);
        }
      });
  }

  switch (activeStep) {
    case 1:
      return (
        <>
          <DialogContent sx={{ width: "100%" }}>
            <Grid
              container
              spacing={2}
              className="d-flex justify-content-center m-0 w-100"
            >
              <DataGrid
                rows={data}
                columns={colunas}
                rowCount={data?.length}
                disableAcoes
                nonPaginated
              />
            </Grid>
          </DialogContent>
          <DialogActions className="w-100 d-flex justify-content-end">
            <Button
              variant="contained"
              onClick={() => {
                setArquivoCsv(null);
                setActiveStep(0);
              }}
            >
              Voltar
            </Button>
            <Button
              variant="contained"
              color="success"
              onClick={() => handleSubmit()}
            >
              Cadastrar
            </Button>
          </DialogActions>
        </>
      );
    case 0:
      return (
        <SelecionarArquivoCsvStep
          setActiveStep={setActiveStep}
          setOpenImportarCSVDialog={setOpenImportarCSVDialog}
          arquivoCsv={arquivoCsv}
          setArquivoCsv={setArquivoCsv}
          buscarCsvData={buscarCsvData}
        />
      );
  }
};

export default ImportarCsvStepper;
